module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/direct/icon_basic-3a7dbe8ab0e4e6dd9ffcd798941ae1b1.svg";